import Heading from "components/Heading/Heading";
import React from "react";
import NcImage from "shared/NcImage/NcImage";
import FounderImage from "images/Founder.png";
import { founderSchema } from "./founderSchema";
import { Helmet } from "react-helmet-async";

const FOUNDER = {
  name: "Prembhai Mali",
  job: "Founder & Mechanical Engineer",
  avatar: FounderImage,
  description:
    "With a strong background in mechanical engineering, Prembhai Mali founded Devi Plastic with a clear vision — to manufacture high-quality sink couplings using precision die-making, advanced processes, and uncompromised quality standards.",
};

const SectionFounder = () => {
  return (
    <div className="nc-SectionFounder relative py-10 sm:py-16 lg:py-24">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(founderSchema)}
        </script>
      </Helmet>
      <Heading desc="Built on engineering excellence, manufacturing precision, and long-term trust.">
        👤 Founder
      </Heading>
      <div className="flex justify-center px-4">
        <div className="w-full max-w-md text-center">
          {/* Founder Image */}
          <NcImage
            containerClassName="relative mx-auto w-full sm:w-full  lg:w-full aspect-w-1 aspect-h-1 rounded-2xl overflow-hidden shadow-xl"
            className="object-cover w-full h-full"
            src={FOUNDER.avatar}
          />

          {/* Name */}
          <h3 className="mt-5 text-lg sm:text-xl md:text-2xl font-semibold text-neutral-900 dark:text-neutral-200">
            {FOUNDER.name}
          </h3>

          {/* Role */}
          <span className="block mt-1 text-sm sm:text-base font-medium text-primary-600 dark:text-primary-400">
            {FOUNDER.job}
          </span>

          {/* Description */}
          <p className="mt-4 text-sm sm:text-sm md:text-base leading-relaxed text-neutral-600 dark:text-neutral-400 px-2">
            {FOUNDER.description}
          </p>

          {/* Highlight */}
          <div className="mt-5 inline-block rounded-full bg-neutral-100 px-4 py-2 text-xs sm:text-sm font-medium text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300">
            Precision Manufacturing • Quality Assurance • Die-Making Expertise
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFounder;
